import React from 'react';
import { PARTNERS } from '../mock';

export default function PartnerBanner() {
  const items = [...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section className="bg-[#f1f1f1] py-14 overflow-hidden border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 mb-10">
        <p className="text-center text-xs tracking-[0.22em] uppercase text-[#125082] font-semibold">Nos marques partenaires</p>
        <h3 className="text-center font-display text-2xl md:text-3xl mt-2">Des technologies de pointe pour votre projet</h3>
      </div>
      <div className="marquee-wrap relative">
        <div className="marquee-track gap-20 px-8 items-center">
          {items.map((p, i) => {
            const baseSize = 56; // px (h-14)
            const visualHeight = Math.round(baseSize * (p.scale || 1));
            return (
              <div key={i} className="flex items-center justify-center h-24 w-52 shrink-0 opacity-95 hover:opacity-100 transition">
                <img
                  src={p.logo}
                  alt={p.name}
                  style={{ height: `${visualHeight}px`, maxWidth: '200px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => { e.target.outerHTML = `<span class='font-display text-2xl text-[#125082]'>${p.name}</span>`; }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
